import React from 'react';
import styled from '@emotion/styled';
import {
  Button,
  Box,
  Typography,
  IconButton} from '@mui/material';
import { Add, Check, Close, DeleteOutlineOutlined } from '@mui/icons-material';
import { useProjectStages } from './useProjectStages';
import { Schema } from '../../toolympus/hooks/useSchema';
import { FormControlsForFields } from '../../toolympus/components/schemed';
import { Buttons, FormGrid, LoadingIndicator, OccupyFreeSpace, SimpleDialog } from '../../toolympus/components/primitives';
import { ProjectStateDisplay } from './ProjectStateDisplay';
import { DeadlineDisplay } from './DeadlineDisplay';
import { ThemeSettings } from '../../theme';
import { AutoSuggestMultiple } from '../../toolympus/components/primitives/AutoSuggests';
import { MembersSuggestionsKey } from './useProjectsList';
import { formatMembers } from './ProjectsList';
import { SupportDisplay } from './SupportDisplay';

interface Props {
  projectId: number;
  schema: Schema;
}

export const ProjectStagesTable = (props: Props) => {
  const { projectId } = props;
  const data = useProjectStages(projectId);
  const { stages } = data;

  return (<>
    <Box sx={{ marginTop: 0 }}>
      <Buttons>
        {data.isLoading && <LoadingIndicator />}

        <OccupyFreeSpace />

        <Button
          startIcon={<Add />}
          size="small"
          color="primary"
          onClick={() => data.newRecord.startEditing()}
        >
          добавить
        </Button>
      </Buttons>

      {stages.map((stage) => (data.editRecord.item?._id === stage._id
        ? (
            <ProjectStageEditWrapper key={stage._id}>
              <ProjectStateDisplay
                forStage
                condensed
                value={data.editRecord.item?.state}
                update={v => data.editRecord.update({ state: v as any })}
                />
              <FormControlsForFields
                data={data.editRecord.item}
                onChange={(o,c) => data.editRecord.update(c)}
                schema={props.schema}
                fields={[
                  ["title", { className: "title", controlProps: { autoFocus: true }}],
                  ["support", { autoComplete: true }],
                  ["members", { control: AutoSuggestMultiple, suggestionsKey: MembersSuggestionsKey }],
                  ["deadline"],
                ]}
                />
              <Buttons className="actions">
                  <IconButton size="small" onClick={() => data.editRecord.item && data.removeRecord.run(data.editRecord.item)}>
                    <DeleteOutlineOutlined />
                  </IconButton>
                  <IconButton size="small" onClick={() => data.editRecord.save()}>
                    <Check />
                  </IconButton>
                  <IconButton size="small" onClick={() => data.editRecord.cancel()}>
                    <Close />
                  </IconButton>
              </Buttons>
          </ProjectStageEditWrapper>)
          : (
            <ProjectStageWrapper key={stage._id} onClick={() => !data.editRecord.item && data.editRecord.startEditing({ ...stage })}>
              <ProjectStateDisplay condensed forStage value={stage.state} />
              <Typography className="title">{stage.title}</Typography>
              <Typography className="memebers"><SupportDisplay condensed value={stage.support} /> {formatMembers(stage.members)}</Typography>
              <DeadlineDisplay value={stage.deadline} noRedZone={stage.state === "completed"} />
            </ProjectStageWrapper>
            )))}
    </Box>

    <Buttons>
      <OccupyFreeSpace />

      {!!stages.length && <Button
        startIcon={<Add />}
        size="small"
        color="primary"
        onClick={() => data.newRecord.startEditing()}
      >
        добавить
      </Button>}
    </Buttons>

    <SimpleDialog
      dialogTitle="Добавить промежуточный дедлайн"
      submitOnModEnter
      save={() => data.newRecord.save()}
      {...data.newRecord.dialog}>
        <FormGrid columns="1fr" noMargin>
          {!!data.newRecord.item &&
            <FormControlsForFields
              data={data.newRecord.item}
              onChange={(o,c) => data.newRecord.update(c)}
              schema={props.schema}
              fields={[
                ["title", { controlProps: { autoFocus: true }}],
                ["deadline"],
                ["members", { control: AutoSuggestMultiple, suggestionsKey: MembersSuggestionsKey }],
                ["state", { autoComplete: true }],
              ]}
              />}

        </FormGrid>
    </SimpleDialog>
  </>);
};

const ProjectStageWrapper = styled(FormGrid)`
  grid-template-columns: max-content 1fr 140px 140px;
  border-bottom: 1px solid ${ThemeSettings.colors.border_light};
  gap: 1rem;

  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin: 0;

  & .title {
  }
`;

const ProjectStageEditWrapper = styled(ProjectStageWrapper)`
  grid-template-columns: max-content 1fr 140px 140px 140px;
  background: ${ThemeSettings.colors.background_panel};
  border-radius: 12px;
  padding: 0.5rem;
  border-bottom: none;
  margin: 0.5rem 0;

  & .actions {
    grid-column: 1 / span 5;
    justify-content: flex-end;
  }
`;